import DashboardSection from "./DashboardSection";

export default function SiteInfo() {
  const data = [
    {
      label: "Location",
      value:
        "603, Yeongdeok-ro, Yeongdeok-eup, Yeongdeok-gun, Gyeongsangbuk-do,Republic of Korea",
    },
    {
      label: "Fuel",
      value: "Bitumincus coal, small hydro, solar",
    },
    {
      label: "Number of power plants",
      value: "20",
    },
  ];
  return (
    <DashboardSection title="Site Information">
      <div className="flex flex-col gap-6 items-stretch">
        {data.map((item, index) => (
          <Item key={index} label={item.label} value={item.value} />
        ))}
      </div>
    </DashboardSection>
  );
}

const Item = ({ label, value }) => {
  return (
    <div className="flex gap-3">
      <p className="w-[75px] flex-shrink-0 text-[#8C8C8C] text-xs leading-[100%]">
        {label}
      </p>
      <p className="flex-grow text-[#242424] text-xs leading-[150%]">{value}</p>
    </div>
  );
};
